import { FilterOptionsState, createFilterOptions } from "@mui/material";

/**
 * The one filtering rule for every dropdown in both apps: an entry stays listed while its label starts
 * with the typed text, compared case-insensitively. Diacritics are deliberately not normalised — MUI's
 * default would let `Ubergabe` match `Übergabe`. The theme applies it to every `Autocomplete`;
 * components that post-process the list (hidden entries) chain this function so the rule is not
 * re-derived per field. The MUI filter is built per call because `createFilterOptions` is typed per
 * option type; a hoisted instance could only be shared through casts.
 */
export function filterDropdownOptions<T>(options: T[], state: FilterOptionsState<T>): T[] {
  return createFilterOptions<T>({ matchFrom: "start", ignoreAccents: false })(options, state);
}
